<ng-template let-item="item">
    <img *ngIf="false" class="filter-small-image" src="https://source.unsplash.com/random/100x100" alt="Icon">
    {{item.name}}
</ng-template>
